export const chats = {
  chatListChatIfoAttachmentsText: 'Wysłano załącznik(ów)',
  chatListChatNoMessagesText: 'Brak wiadomości',
  chatArchivedTitle: 'Zarchiwizowane czaty',
  chatsCreatePrivateCurtainTitle: 'Nowy czat',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Szukaj',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Utwórz',
  chatCreateButtonTitle: 'Dalej',
  chatCreateNewGroupHeader: 'Nowa grupa',
  chatGroupNameInputTitle: 'Nazwa grupy',
  chatLogoTitle: 'Edytuj',
  chatCreateGroupButtonTitle: 'Utwórz grupę',
  chatRequiredFieldsAlert: 'Nazwa grupy musi być podana!',
  chatsCreateGroupChatLongTitleAlertText: 'Proszę użyć krótszego tytułu!',
  chatsCreateGroupChatLBigImageAlertText: 'Proszę wybrać mniejszy obraz!',
  chatsNewChatInputPlaceholder: 'Napisz wiadomość',
  chatsNewChatAddedBigImageAlertText: 'Proszę wybrać mniejszy obraz!',
  chatOwnersArchiveOptionText: 'Zarchiwizuj',
  chatOwnersEditGroupOptionText: 'Edytuj',
  chatOwnersManageGroupOptionText: 'Zarządzaj członkami',
  chatOwnersChangeGroupOptionText: 'Zmień właściciela grupy',
  chatOwnersLeaveGroupOptionText: 'Opuść',
  chatOwnersDeleteGroupOptionText: 'Usuń czat',
  chatpopupArchivedTitle: 'Archiwizuj czat',
  chatpopupArchivedDescription: 'Czy na pewno?',
  chatArchiveGroupButtonTitleYes: 'Potwierdź',
  chatArchiveGroupButtonTitleCancel: 'Anuluj',
  chatEditGroupHeader: 'Edytuj czat',
  chatEditGroupEditLogoTitle: 'Edytuj',
  chatEditGroupButtonTitle: 'Zapisz',
  chatGroupEditAlertText: 'Pomyślnie zapisano!',
  chatManageGroupHeader: 'Zarządzanie',
  chatManageGroupButtonTitle: 'Dodaj członka',
  chatManageGroupSaveButtonTitle: 'Zapisz',
  chatAddUsersGroupHeader: 'Dodaj członków',
  chatAddUsersGroupButtonTitle: 'Potwierdź',
  chatAddUsersGroupSearchInputPlaceholder: 'Szukaj',
  chatOwnershipTransferHeader: 'Przenieś właścicielstwo',
  chatOwnershipTransferSearchInputPlaceholder: 'Szukaj',
  chatOwnershipTransferButtonTitle: 'Potwierdź',
  chatOwnerMarkText: '(ty)',
  chatOwnershipTransferAlertText: 'Właścicielstwo przeniesione!',
  chatOwnerLeaveGroupTitle: 'Opuść grupę',
  chatOwnerLeaveGroupDescription: 'Jesteś właścicielem czatu, więc musisz wybrać nowego właściciela przed opuszczeniem grupy.',
  chatOwnerLeaveGroupButtonTitleYes: 'Wybierz',
  chatOwnerLeaveGroupButtonTitleNo: 'Anuluj',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Zarchiwizuj',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Członkowie czatu',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Opuść',
  chatsGroupChatMemberCurtainTitle: 'Członkowie czatu',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Szukaj',
  chatsGroupChatMemberCurtainOwnerMarkText: '(właściciel)',
  chatsGroupChatLeavePopupTitle: 'Opuść',
  chatsGroupChatLeavePopupText: 'Czy na pewno?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Anuluj',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Potwierdź',
  chatDeleteGroupTitle: 'Usuń czat',
  chatDeleteGroupDescription: 'Czat i jego historia zostaną usunięte dla wszystkich uczestników, kontynuować?',
  chatDeleteGroupButtonTitleYes: 'Potwierdź',
  chatDeleteGroupButtonTitleNo: 'Anuluj',
  chatsPrivateChatCurtainArchOptionTitle: 'Zarchiwizuj',
  chatsEditMessage: 'Edytuj wiadomość',
  chatsCopyMessage: 'Kopiuj wiadomość',
  chatsDeleteMessage: 'Usuń wiadomość',
  chatsSelectMessage: 'Wybierz wiadomość',
  chatMarkTextEdit: '(edytowane)',
  chatCopyMessageAlertText: 'Wiadomość skopiowana!',
  chatDeleteMessageTitle: 'Usuń wiadomość',
  chatDeleteMessageDescription: 'Usunąć tę wiadomość?',
  chatDeleteMessageButtonTitleYes: 'Potwierdź',
  chatDeleteMessageButtonTitleNo: 'Anuluj',
  chatSelectButtonDelete: 'Anuluj',
  chatSelectButtonNo: 'Usuń',
  chatDeleteMessagesTitle: 'Usuń wiadomości',
  chatDeleteMessagesDescription: 'Usunąć te wiadomości?',
  chatDeleteMessagesButtonTitleYes: 'Potwierdź',
  chatDeleteMessagesButtonTitleNo: 'Anuluj',
  chatArchiveButtonRestore: 'Przywróć',
  chatArchiveButtonNo: 'Usuń',
  chatNoUsersCurtainTitle: 'Ups!',
  chatsNoUsersCurtainText: 'Wydaje się, że nie ma innych użytkowników oprócz Ciebie. Zaproś znajomych, aby rozpocząć rozmowę.',
  chatsNoUsersCurtainCancelButtonTitle: 'Anuluj',
  chatsNoUsersCurtainCopyButtonTitle: 'Skopiuj link do aplikacji',
  chatsAppLinkCopiedAlertText: 'Link skopiowany!',
  chatsTooFewUsers: 'Proszę wybrać przynajmniej jednego użytkownika, aby rozpocząć rozmowę!',
  chatsError: 'Coś poszło nie tak!'
}
